import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { defaultAgentConfirmationFormId } from '../DefaultAgentConfirmation';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../../Elements/ids/Buttons/ModalPrimaryButton';
const DefaultAgentConfirmationButtons = ({ closeView, error }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />

      {!error && (
        <ModalPrimaryButton
          text={formatMessage(Messages.defaultAgent_confirmation)}
          formId={defaultAgentConfirmationFormId}
          canSubmit={true}
        />
      )}
    </>
  );
};

export default DefaultAgentConfirmationButtons;
